// Function to get the deal type label
function getLabelForValue(value, typesArray) {
  // Find the corresponding label in the typesArray
  const type = typesArray.find((type) => type.value === String(value));

  // Return the label if found, otherwise return 'Unknown'
  return type ? type.label : "Unknown";
}
export default getLabelForValue;
